var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap"},[(!_vm.isLogin)?[_c('p',{staticClass:"text"},[_vm._v(" 未登录,请先"),_c('el-button',{staticStyle:{"font-size":"20px"},attrs:{"type":"text"},on:{"click":function($event){return _vm.$router.push('login')}}},[_vm._v("登录")])],1)]:_c('logined-home')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }